import React from 'react';
import {connect} from 'react-redux';
import {Map as PropertyMap} from '@homeaway/react-map-components';
import {MAP_CONFIG} from '../../../../utils/constants';
import {EdapProvider} from '@homeaway/react-event-tracking';

export const getLanguageAndRegion = (locale) => {
    const [language, region] = locale ? locale.split('_') : [];
    return {
        language: language || 'en',
        region: region || 'US',
    };
};

export const Map = ({
    mapOptions,
    markers,
    hoveredMarker,
    onMarkerClick,
    selectedMarker,
    selectedPoi,
    fitBoundsPadding,
    site,
}) => {
    const mapData = {
        apiConfigOptions: {
            apiKey: MAP_CONFIG.apiKey,
            appName: 'LANDINGAPP',
            siteName: site.name,
            ...getLanguageAndRegion(site.locale),
        },
        preventDefaultZoom: true,
        preventFitBounds: false,
        options: mapOptions,
    };
    const onMarkerClicked = (uuid) => {
        if (typeof onMarkerClick === 'function') {
            onMarkerClick(uuid);
        }
    };
    return (
        <EdapProvider>
            <PropertyMap
                {...mapData}
                hoveredMarker={hoveredMarker}
                markers={markers}
                isLoading={false}
                allowMapUpdate={false}
                mapHasLoaded={false}
                onMarkerClick={onMarkerClicked}
                selectedMarker={selectedMarker}
                selectedToi={selectedPoi}
                fitBoundsPadding={fitBoundsPadding}
                showLoadingElement={false}
                shouldMapBeExpanded
            />
        </EdapProvider>
    );
};

export function mapStateToProps({config: {site}}) {
    return {
        site,
    };
}

export const MapComponent = connect(mapStateToProps)(Map);

MapComponent.displayName = 'MapComponent';

export default MapComponent;
